import { BaseAsyncValue } from '../../../shared/models/async-value';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { getOneClicVehiclesSelected } from '@ordersnproducts/modules/one-click-order/selectors/one-click-vehicles.selector';

export class OneClicVehicleProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClicVehiclesSelected).pipe(
      filter(vehicle => !!vehicle),
      map(vehicle => {
        return `${vehicle.plate}`;
      }),
    );
  }
}
